import { ErrorBoundary } from "@sentry/react";
import React from "react";
import { ErrorMsg } from "../../../components/AppMessages";
import { LeadManagementReportFilters } from "../../../components/Filters/LeadManagementReportFilters";
import { IframeLayout } from "../../../components/Layouts";
import { IframePageContent } from "../../../components/PageContent";
import { LEAD_MANAGEMENT_REPORT_BTN_FILTERS } from "../../../constants/leadManagementReportContants";

const DetailLevelTwo = () => {
  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        <IframePageContent
          frameId="lead_management_report_detail_level_two"
          filter={<LeadManagementReportFilters filterBtns={LEAD_MANAGEMENT_REPORT_BTN_FILTERS} />}
          iframeUrl={"https://lookerstudio.google.com/embed/reporting/9c36575d-bf17-4043-b6dc-c31c320ea51f/page/p_530vh8r1ld"}
        />
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default DetailLevelTwo;
